import { Row, Col } from 'antd'
import React from 'react'
import TreeFilter from '../../../../../../../components/TreeSelectFilter'

const WorkExperienceFilter = ({
  filterOptions,
  filterValues,
  handleFilterChange,
  handleFilterSearch,
}) => {
  return (
    <>
      <Row gutter={[16, 16]} style={{ margin: 10 }}>
        <Col span={12}>
          <TreeFilter
            label="Function"
            placeholder="Select Function"
            treeData={filterOptions?.functionList}
            value={filterValues?.selectedFunction}
            onChange={handleFilterChange}
            onSearch={handleFilterSearch}
            valueKey='selectedFunction'
          />
        </Col>
        <Col span={12}>
          <TreeFilter
            label="Role"
            placeholder="Select Role"
            treeData={filterOptions?.roleList}
            value={filterValues?.selectedRole}
            onChange={handleFilterChange}
            onSearch={handleFilterSearch}
            valueKey='selectedRole'
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ margin: 10 }}>
        <Col span={12}>
          <TreeFilter
            label="Duration in years"
            placeholder="Select no. of years"
            treeData={filterOptions?.durationYearList}
            value={filterValues?.selectedDurationYear}
            onChange={handleFilterChange}
            valueKey='selectedDurationYear'
          />
        </Col>
        <Col span={12}>
          <TreeFilter
            label="Duration in months"
            placeholder="Select no. of months"
            treeData={filterOptions?.durationMonthList}
            value={filterValues?.selectedDurationMonth}
            onChange={handleFilterChange}
            valueKey='selectedDurationMonth'
          />
        </Col>
      </Row>
    </>
  )
}

export default WorkExperienceFilter
